<script>
	module.exports = {
		components: {
			'info-icon': require('components/svg/info-icon.vue').default,
			'org-logo': require('components/svg/org-logo.vue').default
		},
		data: function () {
			return {
				splashClass: 'bg-1',
				bgRotateTimer: 10,
				skillAndStrategyTooltip:
					'These K-6 units help students deepen their grasp of various skills, strategies, and concepts of reading comprehension. They can be flexibly used at a range of grades depending on the needs of your students.',
				comprehensionTooltip:
					'These K-5 units are based on superb books and paired passages that facilitate precise questioning and focused discussion to enable comprehension of the entire text. Some of the units may be appropriate for higher grades as well due to the richness of the content.',
				novelStudyTooltip:
					'These grade 5-6 units teach deep reading comprehension and comprehension concepts within the context of rich chaptered texts. Some of these units are also appropriate for other grade levels given the themes they explore and the skills and strategies they help students exercise.'
			};
		},
		mounted() {
			let count = 0;
			this.bgRotateKey = setInterval(() => {
				count++;
				this.splashClass = 'bg-' + ((count % 3) + 1);
			}, this.bgRotateTimer * 1000);
		},
		beforeDestroy: function () {
			clearInterval(this.bgRotateKey);
		}
	};
</script>
<style lang="sass">
	@import 'config/colors';
	.lessons-and-units-index {
		div.splash {
			transition: all 2s ease-out;
			background-color: #F6F6F6;
			background-size: cover;
			margin: 1rem;
			padding: .3px 1rem;
			background-repeat: no-repeat;
			height: 30rem;
			margin-left: auto;
			margin-right: auto;
			width: 100%;
			.sidebar {
				display: inline-block;
				h1 {
					font-family: 'Arvo', serif;
					font-size: 1.5rem;
					color: #005c71;
				}
				.menu-item {
					display: inherit;
					font: 1rem "Helvetica Neue", Helvetica, Arial, sans-serif;
					position: relative;
					background-color: #379CB3;
					margin: .2rem;
					padding: 1rem;
					text-decoration: none;
					color: #FFF;
					&:hover {
						background-color: #059fc5;
						cursor: pointer;
					}
					&.return-to-readworks {
						.rw-logo {
							margin: .25rem 0rem .1rem 0rem;
						}
					}
					.info-icon {
						fill: #FFF;
					}
					.description {
						font: .8rem 'Arvo', serif;
						font-style: italic;
						color: #58e5ff;
					}
				}
			}
		}
	}
</style>
<template>
	<main
		id="content"
		class="main lessons-and-units-index"
		role="main">
		<div class="main-content wrapper">
			<div :class="['splash', splashClass]">
				<div class="sidebar">
					<h1>Lesson Plans</h1>
					<div class="side-nav">
						<div class="links">
							<a
								href="/lessons/skill-and-strategy"
								v-tooltip="skillAndStrategyTooltip"
								class="menu-item">
								Skill &amp; Strategy Units
								<info-icon></info-icon>
								<div class="description">Concepts of comprehension</div>
							</a>
							<a
								href="/lessons/comprehension"
								v-tooltip="comprehensionTooltip"
								class="menu-item">
								Comprehension Units
								<info-icon></info-icon>
								<div class="description">Read-aloud &amp; paired text</div>
							</a>
							<a
								href="/lessons/novel"
								v-tooltip="novelStudyTooltip"
								class="menu-item">
								Novel Study Units
								<info-icon></info-icon>
								<div class="description">Multiple genres</div>
							</a>
							<a
								href="/find-content"
								class="return-to-readworks menu-item">
								<div>Return to</div>
								<div>
									<org-logo :width="172"></org-logo>
								</div>
								<div>for Passages and Articles</div>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</main>
</template>
